import { Component, Input, Output, EventEmitter, OnInit, NgModule, ViewChild } from '@angular/core';
import { UserService } from '@service/user/user.service';
import { TransitionHookService } from '@service/transition-hook.service';
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { FormGroup } from '@angular/forms';
import { SharedModule } from 'src/app/shared.module';

@Component({
  selector: 'app-about-block-header',
  templateUrl: './about-block-header.component.html',
  styleUrls: ['./about-block-header.component.scss'],
})
export class AboutBlockHeaderComponent implements OnInit {
  @Input()
  public title: string = '';

  @Input()
  public baseDataObject = null;

  @Input()
  public privacyUserAttributeName: string;

  @Input()
  public checkbox: boolean = false;

  @Input()
  public disableNicknameOnly: boolean;

  @Input()
  public edit: boolean = false;

  @Input()
  public savedisabled: boolean = false;

  @Input()
  public editdisabled: boolean = false;

  @Input()
  public save;

  @Input()
  public cancel: Function = null;

  @Input()
  private atts: string[] = [];

  @Input()
  public tooltip: string;

  @Output()
  public editChange = new EventEmitter();

  @Input()
  public set switchTab(e: EventEmitter<void>) {
    this._switchTab = e;
    this.switchTab.subscribe(() => {
      this.onCancelButton();
    });
  }
  public get switchTab(): EventEmitter<void> {
    return this._switchTab;
  }
  private _switchTab: EventEmitter<void>;

  @Input()
  public form: FormGroup = null;

  @Input()
  public set submitted(val) {
    this._submitted = val;
    this.submittedChange.emit(val);
  }
  public get submitted() {
    return this._submitted;
  }
  private _submitted: boolean = false;

  @Output()
  public submittedChange = new EventEmitter();

  constructor(
    private userService: UserService,
    private transitionHookService: TransitionHookService,
    private matDialog: MatDialog,
  ) {}

  public ngOnInit() {}

  public onSaveButton(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.submitted = true;

      if (this.savedisabled) {
        resolve();
        return;
      }

      this.edit = false;
      this.editChange.emit(this.edit);

      // common error! -> if save isnt defined here - the save function that was given maybe returns no promise?

      this.save(this.atts)
        .then(() => {
          this.transitionHookService.endBeforeLeaveHook();
          resolve();
        })
        .catch(() => reject());
    });
  }

  public onCancelButton() {
    this.edit = false;
    this.transitionHookService.endBeforeLeaveHook();
    this.editChange.emit(this.edit);

    if (this.cancel) this.cancel(this.atts);
  }

  public async startEdit() {
    if (this.editdisabled) return;

    this.edit = true;
    this.editChange.emit(this.edit);

    // when starting an edit - register a hook that will ask the user if he wants to save his edit on transition change before he saved

    this.transitionHookService.startBeforeLeaveHook({
      text: 'Möchtest du die eingegebenen Daten speichern?',

      buttons: [
        {
          text: 'Ja',
          value: true, // stay
        },
        {
          text: 'Nein',
          value: false, // navigate
        },
      ],

      isRouteChangeable: () => {
        // if form is invalid make sure that red errors are displayed
        if (!this.form.valid) {
          for (var i in this.form.controls) {
            this.form.controls[i].markAsTouched();
          }
        }

        return this.form.valid;
      },

      handleRouteChangeableConditionNotMet: () => {
        console.log('routeChangeableConditionNotMetAction fired');

        // inform the user that data couldn't be saved and the route wasn´t changed
        const confirmConfig = {
          text: 'Die Änderungen konnten nicht gespeichert werden. Bitte prüfe ob alles korrekt ist oder rote Hinweise an den Eingaben stehen.',
          buttons: [
            {
              text: 'OK',
              value: false,
            },
          ],
        };
        this.matDialog.open(ConfirmDialogComponent, {
          data: confirmConfig,
          disableClose: false,
          panelClass: ConfirmDialogComponent.cssClass,
        });
      },

      doBeforeRouteChange: () => {
        // save data before changing route
        this.onSaveButton();
      },
    });
  }

  public savePrivacy() {
    const data: any = {};
    data[this.privacyUserAttributeName] = this.baseDataObject[this.privacyUserAttributeName];
    this.userService.updateUser(data);
  }
}

@NgModule({
  declarations: [AboutBlockHeaderComponent],
  imports: [SharedModule, MatSelectModule],
  exports: [AboutBlockHeaderComponent, SharedModule, MatSelectModule],
})
export class AboutBlockHeaderComponentModule {}
